import { createStyleApiClient } from '@wayfinder/style-api-contract/client';

const styleClient = createStyleApiClient();

export const StyleLoader = {
    getStyle: async (vertical, venueId) => styleClient.getStyleV2(venueId, vertical),
};
